import { Component, OnInit, Inject     } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DialogsReturnCode             } from 'src/app/enums/dialogs/returnCode.enum';
import { HandlerManager                } from 'src/app/managers/handler/handler.manager';
import { LoadingManager                } from 'src/app/managers/loading/loading.manager';
import { SessionManager                } from 'src/app/managers/session/session.manager';
import { User                          } from 'src/app/beans/login/user/user.bean';
import { Result } from 'src/app/beans/result/result.bean';
import { SlotModelAuto } from 'src/app/beans/slot-model/slot-model.auto.bean';
import { SlotModel } from 'src/app/beans/slot-model/slot-model.bean';
import { UtilsManager } from 'src/app/managers/utils/utils.manager';

@Component
({
  selector: 'slot.automate.dialog',
  templateUrl: './slot.automate.dialog.html',
  styleUrls: ['./slot.automate.dialog.scss'],
})

export class SlotAutomateDialog implements OnInit
{
  public  _slotAutomate : SlotModelAuto
  public  models    : SlotModel[]

  today: Date = new Date()

  private siteId : number


  constructor
  (
    private dialogRef : MatDialogRef<SlotAutomateDialog>,
    @Inject(MAT_DIALOG_DATA) public data: any,

    private _handler : HandlerManager,
    private _loader  : LoadingManager,
    private _session : SessionManager,
    private _utils : UtilsManager
  ) {}

  ngOnInit(): void
  {

    this.init()

  }

  async init()
  {
    this._slotAutomate = this.data

    this.checkDate()

    this.siteId = this.data.siteId

    this.models = await this.getModels()

    this._slotAutomate.modelId = this._slotAutomate.modelId ? this._slotAutomate.modelId : this.models[0]?.id

    if(this._slotAutomate.dayAdd === 0 && this._slotAutomate.dayAdvance === 0){
      this._slotAutomate.dayAdd = 7
      this._slotAutomate.dayAdvance = 7
      this._slotAutomate.enabled = 1
    }
  }

  checkDate()
  {
    this._slotAutomate.lastDate = this._utils.date().isPrevious(this._slotAutomate.lastDate, this.today) ?
    this._utils.date().toFormat(this.today, "yyyy-MM-dd" ) : this._slotAutomate.lastDate;
  }

  //---------------------------------------------------------------------------------------------------

  async getModels()
  {
    const user = this._session.user().get()

    if (!User.isKind(user)) return // TODO handle user incorrect

    this._loader.start()

    let response = null

    response = await this._handler.slotModel().list((user as User).token, this.siteId)

    this._loader.stop()

    return response.list as SlotModel[];

  }

  async update()
  {

    let response = await this.changeValue()

    if(!Result.isKind(response))
      return

    response = response as Result
    this.dialogRef.close
    (
      {
        code: DialogsReturnCode.SLOTMODEL_AUTO
      }
    )


  }

  cancel()
  {
    this.dialogRef.close
    (
      {
        code: DialogsReturnCode.OPERATION_DECLINED
      }
    )
  }

  //---------------------------------------------------------------------------------------------------

  async changeValue ()
  {
    const user  = this._session.user().get()

    if ( !User.isKind(user) ) return

    this._loader.start()

    this._slotAutomate.holiday = this._slotAutomate.holiday ? 1 : 0
    this._slotAutomate.enabled = this._slotAutomate.enabled ? 1 : 0

    this._slotAutomate.lastDate = this._utils.date().toFormat(this._slotAutomate.lastDate, "yyyy-MM-dd")

    let response = await this._handler.slotModel().automate((user as User).token, this._slotAutomate)

    this._loader.stop()

    return response
  }

  //---------------------------------------------------------------------------------------------------

}
